import {create} from "zustand";
import {getOrganVoucherCountAsync, getUserVoucherCountDcasAsync} from "../../../store/voucher/voucherSlice";
import {getProfileAuthTokenAsync, getProfilesAsync} from "../../../store/profile/profileSlice";
import {getUserCouponCountAsync} from "../../../store/coupon/couponSlice";
import {UserVoucherDTO} from "../../../types/voucher";

interface VoucherState {
    dispatch: any;
    setDispatch: (dispatch: any) => void;
    isLoading: boolean;
    error: Error | null;

    userVoucherCount: number;
    organVoucherCount: number;
    organDcasVoucherCount: number;
    consultingVoucherCount: number;
    couponCount: number;

    setVoucherCounts: (counts: Partial<VoucherState>) => void;
    fetchAllVoucherCounts: () => Promise<void>;
}

export const useVoucherStore = create<VoucherState>()((set, get) => ({
    dispatch: null,  // 초기값
    setDispatch: (dispatch: any) => set({ dispatch }),
    userVoucherCount: 0,
    organVoucherCount: 0,
    organDcasVoucherCount: 0,
    consultingVoucherCount: 0,
    couponCount: 0,
    isLoading: false,
    error: null,

    setVoucherCounts: (counts) => set((state) => ({ ...state, ...counts })),

    fetchAllVoucherCounts: async () => {
        const dispatch = get().dispatch;
        if (!dispatch) return;

        try {
            set({ isLoading: true, error: null });

            // 기존 Redux dispatch 함수들을 직접 API 호출로 변경
            const [userVoucherRes, organVoucherRes, profilesRes, couponRes] = await Promise.all([
                dispatch(getUserVoucherCountDcasAsync()).unwrap(), // 검사이용권
                dispatch(getOrganVoucherCountAsync()).unwrap(), // 소속 이용권
                dispatch(getProfilesAsync()).unwrap(),      // 프로필 이용권 정보
                dispatch(getUserCouponCountAsync()).unwrap() //
            ]);

            let totalDcasQuantity = 0;
            const promises = profilesRes.map(async (profile: any) => {
                const profileToken = await dispatch(
                    getProfileAuthTokenAsync({ userProfileIdx: profile.idx })
                ).unwrap();

                const voucherResponse: UserVoucherDTO = await (await fetch(
                    `${process.env.REACT_APP_BASE_URL}api/v1/dcas/game-content/profile/voucher`,
                    {
                        method: "GET",
                        headers: {
                            Accept: "*/*",
                            Authorization: `Bearer ${profileToken.accessToken}`,
                        },
                    }
                )).json();

                const organDcas = voucherResponse.voucherInformation.find(
                    (voucher: any) =>
                        voucher.whose === "ORGAN_MANAGER" &&
                        voucher.unitVoucherType === "DCAS"
                );

                const consultingVoucher =voucherResponse.voucherInformation.find(
                    (voucher: any) =>
                        voucher.whose === "USER" &&
                        voucher.unitVoucherType === "COUNSELOR"
                );

                if (organDcas) {
                    totalDcasQuantity += organDcas.quantity;
                }

                if (consultingVoucher) {
                    set({
                        consultingVoucherCount: consultingVoucher.quantity
                    })
                }
            });

            await Promise.all(promises);

            set({
                userVoucherCount: userVoucherRes.count,
                organVoucherCount: organVoucherRes.count,
                organDcasVoucherCount: totalDcasQuantity,
                couponCount: couponRes.totalElements,
                isLoading: false
            });
        } catch (error) {
            set({ error: error as Error, isLoading: false });
        }
    },
}));